import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Mission from "@/components/site/Mission";
import Industries from "@/components/site/Industries";
import Services from "@/components/site/Services";
import ConnectStrip from "@/components/site/ConnectStrip";
import ContactForm from "@/components/site/ContactForm";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import ConsentBanner from "@/components/ConsentBanner";
import { Seo } from "@/components/Seo";

const Index = () => {
  const businessJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "AI Montclair",
    "description": "AI-powered automation solutions for small businesses in Montclair and surrounding areas. Specializing in chatbots, scheduling automation, and workflow optimization.",
    "url": "https://montclairaiautomation.com",
    "telephone": "+1-XXX-XXX-XXXX",
    "email": "hello@montclairaiautomation.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Montclair",
      "addressRegion": "NJ",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.8176",
      "longitude": "-74.2090"
    },
    "serviceArea": {
      "@type": "State",
      "name": "New Jersey"
    },
    "services": [
      {
        "@type": "Service",
        "name": "AI Chatbot Development",
        "description": "Custom AI chatbots for customer service and lead generation"
      },
      {
        "@type": "Service", 
        "name": "Business Process Automation",
        "description": "Automated workflows to streamline business operations"
      },
      {
        "@type": "Service",
        "name": "AI-Powered Scheduling",
        "description": "Intelligent scheduling systems for appointments and resources"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "25"
    }
  };

  return (
    <>
      <Seo 
        title="AI Montclair - AI Solutions for Small Businesses"
        description="Transform your small business with AI-powered automation. Expert chatbot development, scheduling systems, and workflow optimization in Montclair, NJ. Book your free consultation today."
        canonical="https://montclairaiautomation.com"
        ogType="website"
        image="https://lovable.dev/opengraph-image-p98pqg.png"
        jsonLd={businessJsonLd}
      />
      <main className="pb-24">
        <Navbar />
      <Hero />
      <Mission />
      <Industries />
      <Services />
      <ConnectStrip />
      <section id="contact" className="py-16 md:py-24">
        <div className="container mx-auto max-w-2xl">
          <header className="mb-8 text-center">
            <h2 className="text-4xl md:text-5xl font-semibold">Contact</h2>
            <p className="text-lg md:text-xl text-muted-foreground mt-2">
              Have a question or want to work together? Send us a message.
            </p>
          </header>
          <ContactForm />
        </div>
      </section>
      <FAQ />
        <Footer />
        <ConsentBanner />
      </main>
    </>
  );
};

export default Index;
